import { all } from 'redux-saga/effects';
import appSaga from '@iso/redux/app/saga';
import authSagas from '@iso/redux/auth/saga';
import dashboardSaga from '@iso/redux/dashboard/saga';
import mqttSaga from '@iso/redux/mqtt/saga';
import transactionSaga from '@iso/redux/transactions/saga';
import widgetsSaga from '@iso/redux/widgets/saga';
import merchantSaga from '@iso/redux/merchant/saga';
import toolsSaga from '@iso/redux/tools/saga';
import accountOfficerSaga from '@iso/redux/account_officer/saga';
import monitoringSaga from '@iso/redux/monitoring/saga';
import onboardingSaga from '@iso/redux/onboarding/saga';
import settlementSaga from '@iso/redux/settlement/saga';
import financeSaga from '@iso/redux/finance/saga';
import filesSaga from '@iso/redux/files/saga';
import notesSaga from '@iso/redux/notes/saga';
import auditLogsSaga from '@iso/redux/auditLogs/saga';

export default function* rootSaga(getState) {
  yield all([
    appSaga(),
    authSagas(),
    mqttSaga(),
    dashboardSaga(),
    widgetsSaga(),
    merchantSaga(),
    toolsSaga(),
    accountOfficerSaga(),
    monitoringSaga(),
    transactionSaga(),
    onboardingSaga(),
    settlementSaga(),
    financeSaga(),
    filesSaga(),
    notesSaga(),
    auditLogsSaga()
  ]);
}
